import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TextModule } from '@library/ui/atoms/text/text.module';

@Component({
  selector: 'app-toolbar-section',
  imports: [TextModule],
  templateUrl: './toolbar-section.component.html',
  styleUrl: './toolbar-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarSectionComponent {
  label = input.required<string>();
}
